import { useTranslation } from "react-i18next";
import { ContentHeader, MainContentArea } from "melco-ui";
import { useGenericDrawer } from "../../hooks/drawer/useGenericDrawer";
import { UserWizardsButton } from "../../components/dashboard/UserWizardsButton";
import { UserWizardForm } from "../../components/dashboard/form/UserWizardForm";
import { useCurrentUser } from "melco-shared-logic";
import { useUserWizardsData } from "../../hooks/dashboard/useUserWizardData";
import { useAppDomain } from "../../hooks/appdomain/useAppDomain";
import { useCurrentProductVariant } from "../../hooks/useCurrentProductVariant";
import { MELCO_CLOUD } from "../../helper/commonHelper";

export const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const referencesWizardDrawer = useGenericDrawer();
  const user = useCurrentUser();
  const { data: userWizards, refetch } = useUserWizardsData(user?.userId);
  const setWizardsDrawerAction = () => {
    refetch()

    const { closeDrawer } = referencesWizardDrawer;
    closeDrawer()

  }
  const productVariant = useCurrentProductVariant();
  const { appTitle } = useAppDomain();
  console.log(appTitle)

  return (
    <>
      <MainContentArea
        contentPadding
        header={
          <ContentHeader
            title={t("main_menu.dashboard")}
            extra={
              <>
                {productVariant === MELCO_CLOUD && <UserWizardsButton
                  referencesDrawer={referencesWizardDrawer}
                />}
              </>
            }
          />

        }
      >


        {userWizards && <UserWizardForm
          onCloseUserWizardsDrawer={setWizardsDrawerAction}
          referencesUserWizardDrawer={referencesWizardDrawer}
          selectedUserId={user?.userId ?? ""}
          userUserWizards={userWizards}
        />
        }


      </MainContentArea>
    </>
  );
};
